// npm mandatory packages (used in frame)

import '@sop/unify-bootstrap';
import '@sop/unify-bootstrapdatepicker';
import '@sop/unify-select2';

import { Color } from '@sop/unify-color';
import { Colors } from '@sop/unify-color';
import * as pNotify from '@sop/unify-pnotify';
import { UnifyMenu } from '@sop/unify-menu';
import * as unifySelectivity from '@sop/unify-selectivity';

export class UnifyCoreNpm {
    constructor() {
    }

    initialize(o) {
        o = typeof o !== 'undefined' ? o : {};
        var brandedColors = typeof o.brandedColors !== 'undefined' ? o.brandedColors : '';
        var colorScheme = typeof o.colorScheme !== 'undefined' ? o.colorScheme : true;
        var exports = typeof o.exports !== 'undefined' ? o.exports : undefined;

        if (brandedColors === '') {
            console.log('Error UnifyCoreNpm, need to be initialized with brandedColors, o:', o);
            return;
        }

        if (colorScheme === '') {
            console.log('Error UnifyCore, need to be initialized with colorScheme, o:', o);
            return;
        }

        var unify = exports || {};

        unify.Color = Color;
        unify.colors = new Colors(brandedColors, colorScheme);
        unify.Colors = Colors;
        unify.menu = UnifyMenu;
        unify.selectivity = unifySelectivity;

        // PNotify wiill not work unless global in window
        window.PNotify = pNotify;
    }
}